export default () => {
  let focusable;

  function handleKey(e) {
    if (e.key === "Tab" || e.keyCode === 9) {
      if (!focusable.length) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    } else if (e.key === "Escape" || e.keyCode === 27) {
      // Do not allow Escape to close the dialog to enforce login
      e.preventDefault();
    }
  }

  // Prevent clicking the backdrop from closing or interacting with page; focus the panel instead
  const backdropClickCapture = e => {
    e.preventDefault();
    if (focusable.length) focusable[0].focus();
    else component.focus();
  };

  document.querySelectorAll(".gated-content__panel").forEach(component => {
    document.querySelector("main").style.zIndex = "1000";
    document.querySelector("main").style.position = "relative";

    // Existing `.inline` class means this should render as a component, not modal
    if(component.classList.contains("inline")) return;
    
    // ensure parent container z-index overrides other elements

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    // Focus management / trap
    var focusableSelectors =
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    focusable = Array.prototype.slice.call(
      component.querySelectorAll(focusableSelectors),
    );

    if (focusable.length) {
      focusable[0].focus();
    } else {
      component.focus();
    }

    document.addEventListener("keydown", handleKey, true);
  });

  document
    .querySelector(".gated-content__backdrop")
    .addEventListener("click", e => {
      // don't capture backdrop clicks for inline modal
      if(document.querySelectorAll(".gated-content__panel.inline").length) return;
      backdropClickCapture(e);
    });
};
